import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import type { Router } from 'vue-router';

const APP_LINK_HOST = 'app.galidancia.com';

/** Convierte una URL https://app.galidancia.com/... en ruta del router Vue. */
export function pathFromAppLinkUrl(urlString: string): string | null {
  try {
    const url = new URL(urlString);
    if (url.protocol !== 'https:' || url.hostname !== APP_LINK_HOST) {
      return null;
    }
    const path = url.pathname + url.search + url.hash;
    if (!path || path === '/') {
      return null;
    }
    return path.startsWith('/') ? path : `/${path}`;
  } catch {
    return null;
  }
}

function navigateFromAppLink(router: Router, urlString: string): void {
  const path = pathFromAppLinkUrl(urlString);
  if (!path) {
    return;
  }
  void router.push(path).catch((err) => {
    console.warn('appUrlOpen: no se pudo navegar a', path, err);
  });
}

/**
 * Android App Links / enlaces universales: abre la ruta correcta al lanzar o reanudar la app.
 * Solo en plataforma nativa (Capacitor).
 */
export function setupAppLinkRouting(router: Router): void {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  void CapacitorApp.getLaunchUrl().then((result) => {
    if (result?.url) {
      navigateFromAppLink(router, result.url);
    }
  });

  CapacitorApp.addListener('appUrlOpen', (event) => {
    navigateFromAppLink(router, event.url);
  });
}
